import {Form, Formik, FormikHelpers} from 'formik'
import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Form as BsForm, Spinner} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {fetchAsyncUserDetails, getAllUserDetails} from '../Overview/OverviewSlice/UserDetailsSlice'
import {useUpdateNotificationSettingsMutation} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'

type VoiceNotificationSettings = {
  voiceBellNotification: boolean
  voiceNotificationEmail: boolean
  voiceNotificationSms: boolean
}

const validationSchema = Yup.object({
  voiceBellNotification: Yup.boolean(),
  voiceNotificationEmail: Yup.boolean(),
  voiceNotificationSms: Yup.boolean(),
})

const VoiceNotification: FC = () => {
  const dispatch = useDispatch()
  const userValues = useSelector(getAllUserDetails)
  const [initialValue, setInitialValue] = useState<VoiceNotificationSettings>({
    voiceBellNotification: false,
    voiceNotificationEmail: false,
    voiceNotificationSms: false,
  })

  const [update, {isLoading}] = useUpdateNotificationSettingsMutation()

  const onSubmit = (
    values: VoiceNotificationSettings,
    formikHelpers: FormikHelpers<VoiceNotificationSettings>
  ) => {
    update({voiceNotificationSettings: values})
      .then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else {
            dispatch(fetchAsyncUserDetails())
            toast.success(res?.data?.message)
          }
        } else if ('error' in res) {
          const resError = res.error as any
          if (resError.data?.message) {
            toast.error(resError.data?.message || '')
          } else {
            toast.error(res?.error.toString() || '')
          }
        }
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  useEffect(() => {
    if (userValues && (userValues as any).voiceNotificationSettings) {
      setInitialValue((userValues as any).voiceNotificationSettings)
    }
  }, [userValues])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title'>
          <h3 className='fs-2'>Voice Notification</h3>
        </div>
      </div>
      <div className='card-body'>
        <Formik
          enableReinitialize
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({values, setFieldValue}) => (
            <Form>
              <div className='first-row'>
                <div className='row align-items-center mb-5'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Bell Notification</label>
                  </div>
                  <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                    <BsForm.Check
                      onChange={() => {
                        setFieldValue('voiceBellNotification', !values.voiceBellNotification)
                      }}
                      checked={values.voiceBellNotification}
                      type='switch'
                      id='voice-bell-notification'
                    />
                  </div>
                </div>

                <div className='row align-items-center mb-5'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Email Notification</label>
                  </div>
                  <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                    <BsForm.Check
                      type='switch'
                      id='voice-email-notification'
                      checked={values.voiceNotificationEmail}
                      onChange={() =>
                        setFieldValue(
                          'voiceNotificationEmail',
                          !values.voiceNotificationEmail
                        )
                      }
                    />
                  </div>
                </div>

                <div className='row align-items-center'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Phone Notification</label>
                  </div>
                  <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                    <BsForm.Check
                      type='switch'
                      id='voice-sms-notification'
                      checked={values.voiceNotificationSms}
                      onChange={() =>
                        setFieldValue(
                          'voiceNotificationSms',
                          !values.voiceNotificationSms
                        )
                      }
                    />
                  </div>
                </div>
              </div>

              <div className='row border-top mt-2 p-4'>
                <div className='col-md-12 text-center text-xl-end text-lg-end text-md-end'>
                  <button
                    data-testid='btnVoiceNotification'
                    className='btn btn-primary fw-500'
                    type='submit'
                  >
                    {isLoading ? <Spinner /> : 'Submit'}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default VoiceNotification


